export const emiratePositions = {
  'Dubai' : {"lat":25.2048493,"lng":55.2707828},
  'Abu Dhabi' : {"lat":24.453884,"lng":54.3773438},
  'Sharjah' : {"lat":25.3462553,"lng":55.4209317},
  'Ajman' : {"lat":25.4052165,"lng":55.5136433},
  'Fujairah' : {"lat":25.1288099,"lng":56.3264849},
  'Ras Al Khaimah' : {"lat":25.8006926,"lng":55.9761994}, 
  'Umm Al Quwain' : {"lat":25.5426324,"lng":55.54753479999999}
}